// extracted by mini-css-extract-plugin
export default {"wrap":"YG-z","fullWidth":"ZG-z","hideOnDesktop":"_G-z","content":"aH-z","hasOpenedNav":"bH-z","crumbsList":"cH-z","dropdownsWrap":"dH-z"};